module.exports = __webpack_public_path__ + "media/theme/facebook-4cd6edf9.png";